import loginShanxian from './shanxian';
const originLoginFunc = {
  initLogin: async params => await loginShanxian.initLogin(params),
  checkLogin: async params => await loginShanxian.checkLogin(params),
  login: async params => await loginShanxian.login(params),
  logout: async params => await loginShanxian.logout(params),
};

const loginPlugin = {
  install(Vue) {
    // Vue.prototype.$loginTgclubPlugin = {
    //   initLogin: login.initLogin,
    //   checkLogin: login.checkLogin,
    //   login: login.login,
    //   logout: login.logout,
    // };
    Vue.prototype.$loginTgclubPlugin = {
      ...originLoginFunc,
    };
  },
};
export default loginPlugin;
export { originLoginFunc };
